import type { FutureProof } from "../types";

export const FUTURE_PROOF: FutureProof = "%future added value";
